import React from 'react'

import Header from '@/components/newHeader/Header'
import LandingHero from '@/components/vets/LandingHero'
import MoreInformation from '@/components/vets/MoreInformation'
import RelatedBlog from '@/components/vets/RelatedBlog'
import Footer from '@/components/newFooter/newFooter'
import SearchResult from '@/components/vets/SearchResult/SearchResult'
import { getAllPosts } from '@/components/blog/lib/cosmic'
import BasicHeadSeo from '@/components/basicHeadSeo'

import { categorizePosts } from '@/components/blog/lib/utils'
import { citiesByState } from '@/utils/countries_and_states'
import { PostDataType } from '@types'

import styles from './index.module.scss'

import { ROBOTS_META } from 'const'

export default function Vets({ posts }) {
  const categorizedPosts = categorizePosts(posts) as Record<
    string,
    PostDataType[]
  >

  return (
    <>
      <BasicHeadSeo
        title="Find a Local Vet | MawooPets.com"
        description="Looking for a reputable veterinarian near you? Our Mawoo Pets veterinary directory is here to help you find some of the best vets and animal clinics in your area."
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/find-a-vet`}
        content={ROBOTS_META}
      />

      <main className={styles.main}>
        <Header />
        <LandingHero citiesByState={citiesByState} />
        <SearchResult citiesByState={citiesByState} />
        <MoreInformation citiesByState={citiesByState} />
        <RelatedBlog categorizedPosts={categorizedPosts} />
        <Footer />
      </main>
    </>
  )
}

export async function getServerSideProps() {
  try {
    const posts = await getAllPosts()

    return {
      props: {
        posts,
      },
    }
  } catch (err) {
    console.error(err)
    throw err
  }
}
